/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popFaceScanLog.vue?vue&type=template&id=684fe655&scoped=true"
import script from "./popFaceScanLog.vue?vue&type=script&lang=js"
export * from "./popFaceScanLog.vue?vue&type=script&lang=js"
import style0 from "./popFaceScanLog.vue?vue&type=style&index=0&id=684fe655&prod&lang=scss&scoped=true"
import style1 from "./popFaceScanLog.vue?vue&type=style&index=1&id=684fe655&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684fe655",
  null
  
)

export default component.exports